import React, { useEffect, useState } from "react";
import "../styles/banner.css";
import "../styles/animation.css";

const Banner = () => {
  const [banners, setBanners] = useState([]);

  const baseUrl = process.env.REACT_APP_API_BASE_URL_DEV;

  // Busca os banners da API
  useEffect(() => {
      fetch(`${baseUrl}/api/banner/`)
      .then((res) => {
        if (!res.ok) throw new Error("Erro ao buscar banners");
        return res.json();
      })
      .then((data) => {
        setBanners(data.banners || []);
        const allImages = data.banners.flatMap((banner) =>
          banner.images.map((img) => img.image)
        );
        preloadImages(allImages);
      })
      .catch((err) => {
        console.error("Erro ao carregar banners:", err);
      });
  }, [baseUrl]);

  // Pré-carrega imagens
  const preloadImages = (images) => {
    const seen = new Set();
    images.forEach((src) => {
      if (!seen.has(src)) {
        const img = new Image();
        img.src = src;
        seen.add(src);
      }
    });
  };

  // Inicializa o carrossel
  useEffect(() => {
    const carouselElement = document.querySelector("#carouselIndicators");
    if (window.bootstrap && carouselElement) {
      new window.bootstrap.Carousel(carouselElement, {
        interval: 6000,
        ride: "carousel",
      });
    }
  }, [banners]);

  return (
    <div className="pb-4">
      <div className="banner">
        <div
          id="carouselIndicators"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="6000"
        >
          {/* Indicadores */}
          <div className="carousel-indicators">
            {banners.map((_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#carouselIndicators"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : undefined}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>

          {/* Slides */}
          <div className="carousel-inner">
            {banners.map((banner, index) => (
              <div
                key={banner.id}
                className={`carousel-item ${index === 0 ? "active" : ""}`}
              >
                {banner.images.map((image) => (
                  <a
                    key={image.id}
                    href={image.link}
                    target="_self"
                    rel="noopener noreferrer"
                    className={image.css_class}
                  >
                    <img src={image.image} alt={image.alt_text} />
                  </a>
                ))}
              </div>
            ))}
          </div>

          {/* Controles de Navegação */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselIndicators"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Anterior</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselIndicators"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Próximo</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;
